import { ROUTES } from "@/enums/routes";
import { RootState } from "@/store/store";
import { Button } from "@/uiComponents/components/ui/button";
import { MoveLeft } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const user = useSelector((state: RootState) => state.auth.profile);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(user != null ? ROUTES.DASHBOARD : ROUTES.LOGIN);
  };
  return (
    <div className="h-screen flex flex-col mb-20 items-center justify-center">
      <div className="text-center font-semibold text-9xl">404 </div>
      <div className="text-center text-2xl  ">Page Not Found </div>
      <Button onClick={handleClick} className="flex cursor-pointer mt-8">
        <MoveLeft size={16} />
        Go back home
      </Button>
    </div>
  );
};

export default NotFoundPage;
